export default __webpack_public_path__ + "static/media/ISKO CLASS 5 SYLLABUS.8bb2233c.pdf";